module.exports = __webpack_public_path__ + "img/dragon.3197ca0a.svg";